// Module
var code = `<main class="page-content">
<!--
  <div data-region="breadcrumbs"></div>
-->
  <div data-region="main"></div>
</main>
`;
// Exports
module.exports = code;